import { type FragmentOf, graphql, readFragment } from "@/graphql"
import {
    type PaymentInstructionStatus,
    PaymentInstructionStatusSchema,
} from "@/scalars/paymentInstructionStatus"

const VALID_PAYMENT_INSTRUCTION_STATUSES = [
    "ACTIVE",
    "PROVISIONAL",
] as const satisfies PaymentInstructionStatus[]

const graphlQLFragments = {
    paymentInstruction: graphql(`
        fragment isPaymentInstructionValid_PaymentInstruction on PaymentInstructionType {
            __typename
            status
        }
    `),
}

export function isPaymentInstructionValid(
    fragment: FragmentOf<typeof graphlQLFragments.paymentInstruction>
) {
    const paymentInstruction = readFragment(graphlQLFragments.paymentInstruction, fragment)
    const paymentInstructionStatus = PaymentInstructionStatusSchema.safeParse(
        paymentInstruction.status
    )

    if (!paymentInstructionStatus.success) {
        return false
    }

    return VALID_PAYMENT_INSTRUCTION_STATUSES.includes(paymentInstructionStatus.data)
}

isPaymentInstructionValid.fragments = graphlQLFragments
